import * as Types from '../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSalesProfileListQueryVariables = Types.Exact<{
  employeeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSalesProfileListQuery = { __typename?: 'Query', salesProfileList: Array<{ __typename?: 'SalesProfileInformation', employeeId: string, iTalkExtension: string, hqlmUrl: string }> };


export const GetSalesProfileListDocument = gql`
    query getSalesProfileList($employeeId: String) {
  salesProfileList(employeeId: $employeeId) {
    employeeId
    iTalkExtension
    hqlmUrl
  }
}
    `;

/**
 * __useGetSalesProfileListQuery__
 *
 * To run a query within a React component, call `useGetSalesProfileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesProfileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesProfileListQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetSalesProfileListQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesProfileListQuery, GetSalesProfileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesProfileListQuery, GetSalesProfileListQueryVariables>(GetSalesProfileListDocument, options);
      }
export function useGetSalesProfileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesProfileListQuery, GetSalesProfileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesProfileListQuery, GetSalesProfileListQueryVariables>(GetSalesProfileListDocument, options);
        }
export type GetSalesProfileListQueryHookResult = ReturnType<typeof useGetSalesProfileListQuery>;
export type GetSalesProfileListLazyQueryHookResult = ReturnType<typeof useGetSalesProfileListLazyQuery>;
export type GetSalesProfileListQueryResult = Apollo.QueryResult<GetSalesProfileListQuery, GetSalesProfileListQueryVariables>;